import ListingApplicationCard from './ListingApplicationCard';

export default ListingApplicationCard;
